import { RouteInfo } from '../vertical-menu/vertical-menu.metadata';

export const HROUTES: RouteInfo[] = [
  {
    path: '/', title: 'Price Check', icon: 'ft-home', class: 'dropdown nav-item', isExternalLink: false, submenu: []
  } ,
  {
    path: 'pages/faq', title: 'FAQ', icon: 'ft-about', class: 'dropdown nav-item', isExternalLink: false, submenu: []
  } ,
  {
    path: 'https://www.nilrx.com/contact-us', title: 'Contact Us', icon: 'ft-about', class: 'dropdown nav-item', isExternalLink: true, submenu: []
  } ,
  {
    path: 'https://www.nilrx.com/about-us', title: 'About Us', icon: 'ft-about', class: 'dropdown nav-item', isExternalLink: true, submenu: []
  } 
];